/**
 * Copy text, with a fallback for browsers that refuse the async Clipboard API.
 *
 * `navigator.clipboard.writeText` rejects in more situations than you would
 * expect — an unfocused document, a non-secure origin, a permissions policy —
 * so the old `execCommand` route stays as a backstop. Returns whether anything
 * actually landed, so the caller can avoid claiming success it did not achieve.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    /* fall through */
  }

  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    // Off-screen but still selectable; `display: none` would break execCommand.
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    textarea.style.opacity = '0';
    textarea.setAttribute('readonly', 'true');
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
